import createMutator from '../../utils/createMutator';

export const addNewGroup = createMutator('set', 'groupInvites');
export const addNewMessage = createMutator('set', 'newMessages');
export const addNewPendingContact = createMutator('set', 'pendingContacts');
export const removeGroupInvite = createMutator('remove', 'groupInvites');
export const removeMessageAlert = createMutator('remove', 'newMessages');
export const removePendingContact = createMutator('remove', 'pendingContacts');
export const setWorkorder = createMutator('set', 'workorder');